export const MSG_META_DATA_ADD_LOGO = 'Type is required to add metadata.';
export const MSG_META_DATA_ADD_VEHICLE_IMAGE = 'All fields are required to add metadata.';
export const MSG_META_DATA_SINGLE_APPLY = 'The tags will be applied to the image that you\'ve uploaded.';
export const MSG_META_DATA_BULK_APPLY = 'The tags will be applied to the entire batch of images that you\'ve uploaded.';
